import {
  IsString,
  IsPhoneNumber,
  IsNotEmpty,
  IsUUID,
  Length,
  IsNumberString,
  Matches,
} from 'class-validator';

import { IsEqualTo, IsSnils } from '@vk-hr-tek/core/validation';

import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  REQUIRED_FIELD_VALIDATION_MESSAGE,
  SMS_CODE_LENGTH,
} from '../../constants';

export class RegisterDto {
  @Length(PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH, {
    message: 'Должен содержать не менее 8 символов',
    groups: ['form'],
  })
  @Matches(/^[A-Za-z0-9!"#{}@$()%^\[\]~\-_&'*+,.\/:;<=>?\\|`]+$/, {
    message:
      'Должен содержать только буквы, цифры или символы !"#{}@$()%^[]~-_&\'*+,./:;<=>?\\|`',
    groups: ['form'],
  })
  @Matches(/[A-Z]/, {
    message: 'Должен содержать не менее 1 заглавной буквы',
    groups: ['form'],
  })
  @Matches(/[a-z]/, {
    message: 'Должен содержать не менее 1 строчной буквы',
    groups: ['form'],
  })
  @Matches(/[!"#{}@$()%^\[\]~\-_&'*+,.\/:;<=>?\\|`]/, {
    message: 'Должен содержать не менее 1 символа',
    groups: ['form'],
  })
  @Matches(/[0-9]/, {
    message: 'Должен содержать не менее 1 цифры',
    groups: ['form'],
  })
  @IsString({
    message: 'Вы забыли ввести пароль',
    groups: ['form'],
  })
  @IsNotEmpty({
    message: 'Вы забыли ввести пароль',
    groups: ['form'],
  })
  password: string;

  @IsEqualTo('password', {
    message: 'Пароли не совпадают',
    groups: ['form'],
  })
  @IsString({
    message: 'Вы забыли ввести пароль',
    groups: ['form'],
  })
  @IsNotEmpty({
    message: 'Вы забыли ввести пароль',
    groups: ['form'],
  })
  passwordRepeat: string;

  @Length(SMS_CODE_LENGTH, SMS_CODE_LENGTH, {
    message: 'Вы указали неверный код',
    groups: ['code-verify'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: 'Вы указали неверный код',
      groups: ['code-verify'],
    },
  )
  @IsString({
    message: 'Вы забыли ввести код',
    groups: ['code-verify'],
  })
  @IsNotEmpty({
    message: 'Вы забыли ввести код',
    groups: ['code-verify'],
  })
  code: string;

  @IsPhoneNumber('RU', {
    message: 'Неверный номер телефона',
  })
  @IsString()
  @IsNotEmpty(REQUIRED_FIELD_VALIDATION_MESSAGE)
  phone?: string;

  @IsUUID()
  @IsString()
  @IsNotEmpty(REQUIRED_FIELD_VALIDATION_MESSAGE)
  inviteCode?: string;

  @IsSnils({
    message: 'Неверный СНИЛС',
  })
  @IsString()
  @IsNotEmpty(REQUIRED_FIELD_VALIDATION_MESSAGE)
  snils?: string;
}
